import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";
import { LANGUAGES_MENU, languageMapping } from "../../../i18n/config";
import i18next from "i18next";
import { useDispatch } from "react-redux";
import { openLanguagePop } from "../../../redux/action/member/memberAction";

const LanguageSettings = ({ className }) => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const dispatch = useDispatch();

  return (
    <Dropdown
      placeholder="Select Language"
      className={`!bg-base-white dark:!bg-[#32383E] dark:!text-base-light-white !border-0 !text-sm !tracking-tighter Language md:max-w-[250px] !min-w-[90px] ${className}`}
      fluid
      selection
      value={i18next?.language}
      onChange={(e, data) => {
        i18n.changeLanguage(data.value);
      }}
      // onClick={() => {
      //   dispatch(openLanguagePop());
      // }}
      options={LANGUAGES_MENU}
      renderLabel={({ flag, text }) => {
        return {
          color: "blue",
          icon: flag && {
            name: flag,
            size: "large",
            style: { marginRight: "1px" },
          },
        };
      }}
    />
  );
};

export default LanguageSettings;
